export const sections = [
  {
    name: 'STOX',
    imageName: 'stox',
  },
  { name: 'posts' },
  { name: 'subscription' },
]
